// Google Material Symbols Rounded / 400 / GRAD 0. Apache-2.0.
// Pinned to bd8cb85bd4bad964fe6918f79665bb40c3a8efef.
import { MaterialSymbol, type MaterialIconProps } from './material-symbol';
const artwork = {
  "outline20": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "M216-96q-29.7 0-50.85-21.15Q144-138.3 144-168v-141q0-14 4.5-25.5T162-356l75-86q9.8-11.14 25.4-11.57 15.6-.43 26.56 10.53Q299-433 299.5-419.5T291-395l-51 59h480l-60-69q-9-11-8.5-25t10.54-24.04Q673-465 688-464.5t26 12.5l84 96q8 10 13 22t5 24.99V-168q0 29.7-21.15 50.85Q773.7-96 744-96H216Zm0-72h528v-96H216v96Zm221-230L302-533q-14-14-14-33.5t14-33.5l202-202q14-14 33.5-14t33.5 14l135 135q14 14 14 33.5T706-600L504-398q-14 14-33.5 14T437-398Zm201-236L538-734 370-566l100 100 168-168ZM216-168v-96 96Z"
    ]
  },
  "outline24": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "M200-80q-33 0-56.5-23.5T120-160v-152q0-14 5-28t15-25l62-70q11-13 28.5-13.5T260-437q11 11 12 27t-10 28l-55 62h546l-53-60q-11-12-10-28t12-27q12-12 29.5-11.5T760-433l60 68q10 11 15 25t5 28v152q0 33-23.5 56.5T760-80H200Zm0-80h560v-80H200v80Zm225-225L284-526q-23-23-22.5-56.5T285-639l196-196q23-23 57-24t57 22l141 141q23 23 24 56t-22 56L538-384q-23 23-56.5 22.5T425-385Zm255-254L539-780 341-582l141 141 198-198ZM200-160v-80 80Z"
    ]
  },
  "filled20": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "M216-96q-30 0-51-21t-21-51v-141q0-14 4.5-25.5T162-356l75-86q10-11 25.5-11.5T289-443q10 10 10.5 23.5T291-395l-51 59h480l-60-69q-9-11-8.5-25t10.5-24q11-11 26-10.5t26 12.5l84 96q8 10 13 22t5 25v141q0 30-21 51t-51 21H216Zm221-302L302-533q-14-14-14-33.5t14-33.5l202-202q14-14 33.5-14t33.5 14l135 135q14 14 14 33.5T706-600L504-398q-14 14-33.5 14T437-398Zm201-236L538-734 370-566l100 100 168-168Z"
    ]
  },
  "filled24": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "M200-80q-33 0-56.5-23.5T120-160v-152q0-14 5-28t15-25l62-70q11-13 28.5-13.5T260-437q11 11 12 27t-10 28l-55 62h546l-53-60q-11-12-10-28t12-27q12-12 29.5-11.5T760-433l60 68q10 11 15 25t5 28v152q0 33-23.5 56.5T760-80H200Zm224-304L285-525q-23-23-23-57t23-57l196-196q23-23 57-23t57 23l141 139q23 23 23.5 56.5T737-583L537-383q-23 23-56.5 22.5T424-384Zm256-256L538-780 340-582l142 140 198-198Z"
    ]
  }
} as const;
export function HowToVoteIcon(props: MaterialIconProps) { return <MaterialSymbol {...props} symbol="how_to_vote" artwork={artwork} />; }
